









import { Component, Prop, Vue } from 'vue-property-decorator';
import UserIcon from '@/components/global/UserIcon.vue';
import UserName from '@/components/global/UserName.vue';

@Component({
  components: {
    UserIcon,
    UserName,
  },
})
export default class UserChatButton extends Vue {
  @Prop({ required: true }) id!: string;
}
